import { n as y, _ as d, g as T, b as _, p as O, q as S, s as w, o as A, u as F, v as R, w as C, a as V, f as $ } from "./export-cdcbfb2b.js";
import { i as x } from "./is-pure-c0f11fe0.js";
import { p as D } from "./es.symbol.description-6025a604.js";
import { i as G } from "./inherit-if-required-f068457b.js";
import { t as M } from "./this-number-value-32e86ff7.js";
import { s as U } from "./string-trim-14e37ad3.js";
var j = d, h = x, q = S, I = T, g = D, E = _, L = O, l = w, W = G, X = R, Y = C, P = V, B = $, z = y.f, H = A.f, J = F.f, K = M, Q = U.trim, f = "Number", o = I[f];
g[f];
var m = o.prototype, Z = I.TypeError, k = E("".slice), u = E("".charCodeAt), rr = function(t) {
  var r = P(t, "number");
  return typeof r == "bigint" ? r : tr(r);
}, tr = function(t) {
  var r = P(t, "number"), e, i, a, v, s, b, n, c;
  if (Y(r))
    throw new Z("Cannot convert a Symbol value to a number");
  if (typeof r == "string" && r.length > 2) {
    if (r = Q(r), e = u(r, 0), e === 43 || e === 45) {
      if (i = u(r, 2), i === 88 || i === 120)
        return NaN;
    } else if (e === 48) {
      switch (u(r, 1)) {
        case 66:
        case 98:
          a = 2, v = 49;
          break;
        case 79:
        case 111:
          a = 8, v = 55;
          break;
        default:
          return +r;
      }
      for (s = k(r, 2), b = s.length, n = 0; n < b; n++)
        if (c = u(s, n), c < 48 || c > v)
          return NaN;
      return parseInt(s, a);
    }
  }
  return +r;
}, N = L(f, !o(" 0o1") || !o("0b1") || o("+0x1")), er = function(t) {
  return X(m, t) && B(function() {
    K(t);
  });
}, p = function(r) {
  var e = arguments.length < 1 ? 0 : o(rr(r));
  return er(this) ? W(Object(e), this, p) : e;
};
p.prototype = m;
N && !h && (m.constructor = p);
j({ global: !0, constructor: !0, wrap: !0, forced: N }, {
  Number: p
});
var ar = function(t, r) {
  for (var e = q ? z(r) : (
    // ES3:
    "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(",")
  ), i = 0, a; e.length > i; i++)
    l(r, a = e[i]) && !l(t, a) && J(t, a, H(r, a));
};
(N || h) && ar(g[f], o);
